import { useState, useCallback } from 'react'

interface ViaCepResponse {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string
  uf: string
  erro?: boolean
}

export interface CepAddress {
  street: string
  neighborhood: string
  city: string
  state: string
}

export function useCepLookup() {
  const [isLoading, setIsLoading] = useState(false)

  const lookup = useCallback(async (rawCep: string): Promise<CepAddress | null> => {
    const cep = rawCep.replace(/\D/g, '')
    if (cep.length !== 8) return null

    setIsLoading(true)
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      if (!res.ok) return null

      const data: ViaCepResponse = await res.json()
      if (data.erro) return null

      return {
        street: data.logradouro,
        neighborhood: data.bairro,
        city: data.localidade,
        state: data.uf,
      }
    } catch {
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { lookup, isLoading }
}
